let unauthorizedHandler: (() => void) | undefined;

export function registerUnauthorizedHandler(handler: () => void) {
  unauthorizedHandler = handler;

  return () => {
    if (unauthorizedHandler === handler) {
      unauthorizedHandler = undefined;
    }
  };
}

function notifyUnauthorized() {
  unauthorizedHandler?.();
}

export function handleUnauthorizedResponse(response: Response) {
  if (response.status !== 401) {
    return response;
  }

  notifyUnauthorized();

  return response;
}
